import { render, staticRenderFns } from "./newsTemplate.vue?vue&type=template&id=3f5d5b1e&scoped=true&"
import script from "./newsTemplate.vue?vue&type=script&lang=js&"
export * from "./newsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5d5b1e",
  null
  
)

export default component.exports